import hasRoles from "../../../../security/hasRoles";
import keycloak from "../../../../security/keycloak-config";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import "./stylesGalleryItem.css";
import { Card, Col, Modal, ModalBody, ModalHeader } from "reactstrap";
import ImageGallery from "react-image-gallery";
import { translate } from "react-switch-lang";
import styles from "./galleryImageItem.module.scss";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import ButtonMui from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import UpdateImagesGallery from "../../../Support/update-images-gallery/updateImagesGallery";
import ClickAwayListener from "react-click-away-listener";
import { StatisticMediaDto } from "../../../../models/statisticMediaDto";
import { ACTION } from "../../../../models/action";
import { ExpositionDto } from "../../../../models/expositionDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

const GalleryItem: React.FC<{
  t?: (key: string) => {};
  handlerListener: any;
  setFilteredDocuments: any;
  deleteExposition: any;
  resetAllFieldSearch: () => void;
  info: any;
  exposition: any;
  filterLanguage?: string;
}> = props => {
  const httpClient = useHttpClient(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const theme = useTheme();
  const useStyles: any = makeStyles({
    root: {
      maxWidth: 400,
      flexGrow: 1,
    },
    dot: {
      backgroundColor: "gray !important",
    },
    dotActive: {
      backgroundColor: "green !important",
    },
  });
  const classes = useStyles();
  const location = useLocation();
  const [langdropdown, setLangdropdown] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [, setListExpositionImage] = React.useState<
    {
      original: string;
      thumbnail: string;
    }[]
  >(props?.info?.listExpositionImage?.map(img => ({ original: img.urlImage, thumbnail: img.urlImage })));
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [openModalGallery, setOpenModalGallery] = useState<boolean>(false);  
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const handleClickOpenModalViewer = (data: ExpositionDto) => {
    if (!openModalViewer) {
      if (!hasRoleAdmin) {
        let statisticMediaDto = new StatisticMediaDto();
        statisticMediaDto.categoryId = data.categoryId;
        statisticMediaDto.typeCategory = "2";
        statisticMediaDto.mediaId = data.expositionId;
        statisticMediaDto.action = ACTION.VIEW;
        httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
      }
      setOpenModalViewer(!openModalViewer);
    } else {
      setOpenModalViewer(!openModalViewer);
    }
  };

  const handleClickOpenModalUpdateGallery = () => {
    setOpenModalGallery(!openModalGallery);
  };

  useEffect(() => {
    let list: {
      original: string;
      thumbnail: string;
    }[] = [];
    props.exposition.map(img => {
      return list.push({ original: img.urlImage, thumbnail: img.urlImage });
    });
    setListExpositionImage(props.info.listExpositionImage.map(img => ({ original: img.urlImage, thumbnail: img.urlImage })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LanguageSelection = language => {
    setLangdropdown(!langdropdown);
  };

  const handleSetLanguage = key => {
    setLangdropdown(!langdropdown);
  };

  const getStepsNumber = (steps: number): number => {
    if (steps > 16 && window.innerWidth >= 400) {
      return 15;
    } else if (steps > 12 && window.innerWidth < 400) {
      return 11;
    } else return steps;
  };

  // ─── Deep-link copy ─────────────────────────────────────────────────────────
  // Copies a URL that encodes the current exposition ID and image index.
  // Opening that URL will land on this page and auto-open the viewer at the
const handleCopyLink = (images: { urlImage: string }[]) => {
  if (!images || images.length === 0 || activeStep >= images.length) {
    toast.error("Aucun lien disponible");
    return;
  }
  // window.location.pathname — includes the basename in production
  const encodedPath = window.location.pathname
    .split("/")
    .map(segment => encodeURIComponent(segment))
    .join("/");

  const shareableUrl = `${window.location.origin}${encodedPath}?expositionId=${props.info.expositionId}&imageIndex=${activeStep}`;

  navigator.clipboard.writeText(shareableUrl)
    .then(() => toast.success("Lien copié !"))
    .catch(() => toast.error("Erreur lors de la copie"));
};

  return (
    <Col xl="col-sm-6 col-md-6 col-xl-3">
      <Modal isOpen={openModalViewer} toggle={() => handleClickOpenModalViewer(new ExpositionDto())} size="lg">
        <ModalHeader toggle={() => setOpenModalViewer(!openModalViewer)}></ModalHeader>
        <ModalBody>
          <ImageGallery
            items={props.info.listExpositionImage.map(img => ({ original: img.urlImage, thumbnail: img.urlImage }))}
            thumbnailPosition={"bottom"}
            showBullets={true}
            showPlayButton={true}            
          />
        </ModalBody>
      </Modal>
      <Modal isOpen={openModalGallery} toggle={handleClickOpenModalUpdateGallery} size="lg">
        <ModalBody className="p-0">
          <div>
            <h6 className={styles["title-model"] + " "}>{props.t("title_update_exhibit")}</h6>
          </div>
          <UpdateImagesGallery
            type={null}
            exposition={props.info}
            getListSupport={props.handlerListener}
            onUpdate={props.handlerListener}
            resetAllFieldSearch={() => {
              props.resetAllFieldSearch();
            }}
            closeToggle={handleClickOpenModalUpdateGallery}
            categoryId={location.pathname.split("/")[3]}
            path={location.pathname.split("/")[2]}
          ></UpdateImagesGallery>
        </ModalBody>
      </Modal>

      <Card className={styles["card-document"]}>
        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
          <div className="product-img text-center">
            <SwipeableViews style={{ height: "195px", overflow: "hidden" }} axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={activeStep} onChangeIndex={handleStepChange} enableMouseEvents>
              {props.info.listExpositionImage
                .map(img => ({ original: img.urlImage, thumbnail: img.urlImage }))
                .map((step, index) => (
                  <div key={"index" + index + "___element"}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <Box
                        onClick={() => handleClickOpenModalViewer(props.info)}
                        component="img"
                        sx={{
                          height: 195,
                          display: "block",
                          overflow: "hidden",
                          width: "100%",
                        }}
                        src={step.thumbnail}
                        alt={""}
                      />
                    ) : null}
                  </div>
                ))}
            </SwipeableViews>
            <div className={styles["product-hover"] + " product-hover"}>
              <ul>
                <li>
                  <i className="icon-eye" onClick={() => handleClickOpenModalViewer(props.info)}>
                    <span className="m-l-5">{hasRoleAdmin && props.info.numberView}</span>
                  </i>
                </li>
                <li
                  onClick={() => handleCopyLink(props.info?.listExpositionImage)}
                  style={{ width: "auto", cursor: "pointer" }}
                >
                  <i className="fa fa-share-alt" />
                </li>
              </ul>
              <br />
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <MobileStepper
              classes={{
                root: classes.root,
                dotActive: classes.dotActive,
                dot: classes.dot,
              }}
              style={{ color: "red", flexGrow: 1 }}
              steps={getStepsNumber(props?.info?.listExpositionImage?.length)}
              position="static"
              color="success"
              activeStep={activeStep}
              nextButton={
                <ButtonMui
                  color="success"
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === props?.info?.listExpositionImage?.length - 1}
                >
                  <KeyboardArrowRight />
                </ButtonMui>
              }
              backButton={
                <ButtonMui color="success" size="small" onClick={handleBack} disabled={activeStep === 0}>
                  <KeyboardArrowLeft />
                </ButtonMui>
              }
            />
          </div>

          <div className="blog-details-main">
            <h6 title={props.info.title} className={styles["title-card"] + " blog-bottom-details"}>
              {props.filterLanguage === "Anglais" 
              ? props.info.titleEn 
              : props.filterLanguage === "Français" 
              ? props.info.titleFr 
              : selectedLanguage === "en" ? props.info.titleEn : props.info.titleFr}
            </h6>
            <hr />
            <ul className="blog-social">
              <li className="digits">
                <i className={styles["icon-timer"] + " icofont icofont-ui-timer"}></i> {props.info.dateExposition}
              </li>
              <li className="digits">
                <span title={props.info.listCountry.map(element => selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais).toString()}>
                  {props.info.listCountry.length === 1 ? selectedLanguage === "en"
                    ? props.info?.listCountry[0]?.titleAnglais
                    : props.info?.listCountry[0]?.titleFrancais : props.t("multi_countries")}
                </span>
              </li>
              {hasRoleAdmin && (
                <li className="digits">
                  <ClickAwayListener onClickAway={() => setLangdropdown(false)}>
                    <div className={`${styles["translate_wrapper"]} ${langdropdown ? styles["active"] : ""}`}>
                      <div className={styles["current_lang"]}>
                        <div className={styles["lang"]} onClick={() => LanguageSelection(langdropdown)}>
                          <i className="fa fa-gear"></i>
                        </div>
                      </div>

                      <div className={`${styles["more_lang"]} ${langdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            event.stopPropagation();
                            handleSetLanguage("en");
                            handleClickOpenModalUpdateGallery();
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-edit " + styles["icon-update"]}></i>
                          <span className={styles["lang-txt"]}>{props.t("button_update")}</span>
                        </div>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            handleSetLanguage("fr");
                            event.stopPropagation();
                            props.deleteExposition(props.info.expositionId);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-trash " + styles["icon-delete"]}></i>
                          <span className={styles["lang-txt"]}>{props.t("button_delete")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </Col>
  );
};
export default translate(GalleryItem);
